import React, { createContext, useContext, useState } from 'react';
import HandbookModal from '../components/modals/HandbookModal';

const HandbookContext = createContext();

export const HandbookProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [section, setSection] = useState('overview');

    const openHandbook = (slug = 'overview') => {
        setSection(slug);
        setIsOpen(true);
    };

    const closeHandbook = () => {
        setIsOpen(false);
    };

    return (
        <HandbookContext.Provider value={{ openHandbook, closeHandbook }}>
            {children}
            <HandbookModal isOpen={isOpen} onClose={closeHandbook} initialSection={section} />
        </HandbookContext.Provider>
    );
};

export const useHandbook = () => useContext(HandbookContext);
